export const authModalLayouts = {
  login: 'login',
  registration: 'registration',
  resetPass: 'reset',
  resolveRegistrationConflict: 'send-email'
};
